export default __webpack_public_path__ + "static/media/visa.699944fe.svg";